import { css } from '@emotion/react'

export const viewOnDark = ({ theme, view }) => {
  if (theme === "dark") {
    if (view === "primary") {
      return css({
        color: "var(--color-primary-200)",

        "&:hover": {
          color: "var(--color-primary-400)",
        },

        "&:hover > span:before": {opacity: 1}
      })
    }

    else if (view === "secondary") {
      return css({
        color: "var(--color-grayscale-200)",

        "&:hover": {
          background: "var(--color-white)",
        },

        "&:hover > span:before": {opacity: 1}
      })
    }

    else if (view === "tertiary") {
      return css({
        color: "var(--color-grayscale-500)",

        "&:hover": {
          color: "var(--color-grayscale-200)",
        }
      })
    }
  }
}
